import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  TableCaption,
} from "../ui/table";
import { pricingTable } from "../../data/servicesContent";

/**
 * Tableau comparatif des tarifs individuels (section L de la plaquette).
 * Le composant Table (shadcn) s'enveloppe déjà dans un conteneur
 * `overflow-auto`, ce qui permet un défilement horizontal lisible sur
 * mobile plutôt qu'un tableau tassé/illisible.
 */
const PricingTable = () => {
  return (
    <div className="rounded-2xl border border-[#DCB071]/40 bg-[#FDFBF5] p-2 md:p-4 shadow-sm">
      <Table>
        <TableCaption className="px-2">{pricingTable.caption}</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead className="text-[#21167D] font-semibold whitespace-nowrap">—</TableHead>
            {pricingTable.columns.map((col) => (
              <TableHead
                key={col}
                className="text-[#21167D] font-semibold min-w-[180px] align-bottom"
              >
                {col}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {pricingTable.rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell className="font-medium text-[#21167D] whitespace-nowrap">
                {row.label}
              </TableCell>
              {row.values.map((value, index) => (
                <TableCell key={index} className="text-[#4A4458]">
                  {value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PricingTable;
